import { render, staticRenderFns } from "./pogs-form__item--pregnancy-morbidities.vue?vue&type=template&id=2b18f147&"
import script from "./pogs-form__item--pregnancy-morbidities.vue?vue&type=script&lang=js&"
export * from "./pogs-form__item--pregnancy-morbidities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports